import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Language } from 'gatsby-plugin-i18next'
import chevron from '../../img/cheron-down-languages.svg'


// Lets import styles for component
import './LanguageSwitcher.sass'
class LanguageSwitcher extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false
    }
  }

  componentDidMount = () => {
    const {lng} = this.props
    if (lng === 'ru') {
      this.setState(() => {
        return {
          checked: true,
        }
      })
    } else{
      this.setState(() => {
        return {
          checked: false,
        }
      })
    }
  }

  switchLang = () => { 
    const { lng, changeLng } = this.props
    changeLng(lng === 'ru' ? 'en' : 'ru')
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('@igorkoLng', lng === 'ru' ? 'en' : 'ru')
    }
  }

  render() {
    const {checked} = this.state
    const { t } = this.props
    return (
      <>
        <button type="button" aria-label={checked ? t('header_lng_switcher_ru') : t('header_lng_switcher_en')}>
          {checked ? t('header_lng_switcher_ru') : t('header_lng_switcher_en')}
          <img src={chevron} alt="chevron down"/>
        </button>
        <div className="langDropdown">
          <button type="button" onClick={() => this.switchLang()} aria-label={checked ? t('header_lng_switcher_ru') : t('header_lng_switcher_en')}>
            {!checked ? t('header_lng_switcher_ru') : t('header_lng_switcher_en')}
          </button>
        </div>
      </>
    )
  }
}

export default props => (
  <Language>
    {lngProps => <LanguageSwitcher {...props} {...lngProps} />}
  </Language>
)

LanguageSwitcher.propTypes = {
  t: PropTypes.func.isRequired,
}




